import Vue from 'vue'
import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css'

import LayoutTop from "@/components/LayoutTop";
import banner from "@/components/Banner";
import Menu from "@/components/Menu";
import TabNew from "@/components/TabNew";
import Bottom from "@/components/Bottom";
import LayoutTab from "@/components/LayoutTab";
import abImg from "@/components/abImg";
import empty from "@/components/empty";
import uploadImg from "@/components/uploadImg";
import commonBanner from "@/components/commonBanner";

Vue.component('LayoutTop', LayoutTop)
Vue.component('Menu', Menu)
Vue.component('Banner', banner)
Vue.component('TabNew', TabNew)
Vue.component('Bottom', Bottom)
Vue.component('LayoutTab', LayoutTab)
Vue.component('ab-img', abImg)
Vue.component('empty', empty)
Vue.component('uploadImg', uploadImg)
Vue.component('commonBanner', commonBanner)

Vue.prototype.$mainColor = '#a3c31d';

import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);


import ABcheckbox from '@/components/ABcheckbox'
Vue.component('ab-checkbox', ABcheckbox)
import ABinput from '@/components/ABinput'
Vue.component('ab-input', ABinput)
import ABselect from '@/components/ABselect'
Vue.component('ab-select', ABselect)
import ABradio from '@/components/ABradio'
Vue.component('ab-radio', ABradio)
import ABdate from '@/components/ABdate'
Vue.component('ab-date', ABdate)

Vue.prototype.isMobile = function (v) {
  return /^((13[0-9])|(14[0-9])|(15[0-9])|(18[0-9])|(17[0-9])|(16[0-9])|(19[0-9]))\d{8}$/.test(v)
}

// 判断身份证
Vue.prototype.isIdNo = function (v) {
   return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(v)
 }
import vueFilter from './utils/filters.js'
Object.keys(vueFilter).forEach(k => Vue.filter(k, vueFilter[k]))



// WEBPACK FOOTER //
// ./src/global.js